// Actions
import { leaveClick, nextCheck, runCurrentTestAgain } from 'REDUCERS/navSlice';
import { end as browserEnd, start as browserStart } from 'REDUCERS/browserSlice';
import { end as cameraEnd, start as cameraStart } from 'REDUCERS/cameraSlice';
import { end as microphoneEnd, start as microphoneStart } from 'REDUCERS/microphoneSlice';
import { end as speakersEnd, start as speakersStart } from 'REDUCERS/speakersSlice';
import { end as connectivityEnd, start as connectivityStart } from 'REDUCERS/connectivitySlice';

// Utils
import { CAMERA_CHECK, DONE, PENDING, SUCCESS_LEVEL, UNKNOWN_LEVEL } from 'UTILS/constants';
import { onTrackedResult } from 'UTILS/callbacks';

const startCheck = {
  'browser': browserStart,
  'camera': cameraStart,
  'microphone': microphoneStart,
  'speakers': speakersStart,
  'connectivity': connectivityStart,
};

const extractCheckRegex = /(.*)\/end/;

export default store => next => action => {
  switch (action.type) {
    case nextCheck.toString(): {
      next(action);
      const currentCheck = store.getState().nav.currentCheck;
      if (store.getState().checks[currentCheck]?.stage === PENDING) {
        return store.dispatch(startCheck[currentCheck]());
      }
      if (store.getState().checks[currentCheck]?.stage === DONE) {
        if (store.getState().checks[currentCheck].level === SUCCESS_LEVEL) {
          return store.dispatch(nextCheck());
        }
      }
      return;
    }
    case browserEnd.toString():
    case cameraEnd.toString():
    case microphoneEnd.toString():
    case speakersEnd.toString():
    case connectivityEnd.toString(): {
      const currentCheck = store.getState().nav.currentCheck;
      next(action);
      const endingCheck = action.type.match(extractCheckRegex)[1];
      onTrackedResult(endingCheck, store.getState().checks[endingCheck].level);
      if (store.getState().checks[endingCheck].level === SUCCESS_LEVEL && currentCheck === endingCheck) {
        store.dispatch(nextCheck());
      }
      return;
    }
    case runCurrentTestAgain.toString(): {
      const currentCheck = store.getState().nav.currentCheck;
      return store.dispatch(startCheck[currentCheck]());
    }
    case leaveClick.toString(): {
      const backUrl = store.getState().app.backUrl;
      const closeOnBack = store.getState().app.closeOnBack;
      if (closeOnBack) {
        return window.close();
      }
      if (backUrl) {
        next(action);
        const backUrlObject = new URL(store.getState().app.backUrl);
        const mainLevel = Object.values(store.getState().checks).reduce((mainLevel, { level }) => level === UNKNOWN_LEVEL ? UNKNOWN_LEVEL : Math.max(level, mainLevel), UNKNOWN_LEVEL);
        backUrlObject.searchParams.set('success', mainLevel);
        window.location = backUrlObject.href;
      }
      return;
    }
    default:
      return next(action);
  }
};
